import React, { useState } from "react";
import { passwordChange } from "../../Services/authService";
import { toast } from "react-toastify";

const ChangePassword = ({ onClose }) => {
  const [password, setPassword] = useState();
  const [loader, setLoader] = useState();

  const handleClick = async (e) => {
    e.preventDefault();
    setLoader(true);
    const { new_password, old_password, confirm_password } = password;
    if (new_password == confirm_password) {
      const { ok, message } = await passwordChange({ new_password, old_password })
      if (ok) {
        toast.success(message || "Success")
      }
    } else {
      toast.error("Confirm password not matched")
    };
    setLoader(false);
    onClose();
  };

  return (
    <div
      className="modal custom-modal fade bank-details show"
      id="add_items"
      role="dialog"
      aria-modal="true"
      style={{
        display: "block",
        background: "rgb(0 0 0 / 50%)",
      }}
    >
      <form onSubmit={(e) => handleClick(e)}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="form-header text-start mb-0">
                <h4 className="mb-0">Change Password</h4>
              </div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => onClose()}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="bank-inner-details">
                <div className="row">
                  <div className="col-lg-12 col-md-12">
                    <div className="form-group">
                      <label>Old Password</label>
                      <input
                        required
                        type="text"
                        className="form-control"
                        placeholder="Old Password"
                        value={password?.old_password}
                        onChange={(e) => {
                          setPassword({
                            ...password,
                            old_password: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12">
                    <div className="form-group">
                      <label>New Password</label>
                      <input
                        required
                        type="text"
                        className="form-control"
                        placeholder="New Password"
                        value={password?.new_password}
                        onChange={(e) => {
                          setPassword({
                            ...password,
                            new_password: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12">
                    <div className="form-group">
                      <label>Confirm Password</label>
                      <input
                        required
                        type="text"
                        className="form-control"
                        placeholder="Confirm Password"
                        value={password?.confirm_password}
                        onChange={(e) => {
                          setPassword({
                            ...password,
                            confirm_password: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="bank-details-btn">
                <button
                  data-bs-dismiss="modal"
                  className="btn bank-cancel-btn me-2"
                  onClick={() => onClose()}
                  disabled={loader}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn bank-save-btn"
                  disabled={loader}
                >
                  {loader ? "Loading..." : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ChangePassword;
